import { PaginatorComponent } from "./paginator/paginator.component"

export const UiComponents = [
    PaginatorComponent
]
export {
  PaginatorComponent
}
